import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useMounted from "../../hooks/useMounted";
import { ArrowUpRightIcon, BackButtonIcon } from "../../assets/icons";
import { Image } from "react-bootstrap";
// import dummyUser from "../../assets/images/navigation-bar/dummy-user.png"
import {
  Dropdown,
  // Image,
  Button,
  ToastContainer,
  Toast,
} from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { logOut } from "../../modules/Auth/authSlice";
import { useLoader } from "../../context/LoaderContext";
import { getOrganizationDetails } from "../../modules/Organization/organizationSlice";

import {
  // UserStoryIcon,
  Logout03Icon,
  CheckmarkBadge04Icon,
} from "../../assets/icons";
import "./navbar.css";

export default function NavigationBar() {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const selected_organization_id =
    pathSegments.length > 1 && pathSegments[0] === "organization"
      ? pathSegments[1]
      : null;

  const getUserInitial = (name) => {
    return name
      ? name
          .split(" ")
          .map((n) => n.charAt(0))
          .join("")
          .toUpperCase()
      : "UN";
  };
  const hasMounted = useMounted();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setLoading } = useLoader();
  const [showToast, setShowToast] = useState(false);
  const { organizationDetails } = useSelector((state) => state.organizations);
  const [title, setTitle] = useState("dashboard");
  const [toastMessage, setToastMessage] = useState("");
  const [toastVariant, setToastVariant] = useState("toast-success");

  const user = localStorage.getItem("admin-user-data");
  let userData = null;
  if (user) {
    userData = JSON.parse(user);
  }

  const category = localStorage.getItem("admin-category-data");
  let categoryData = null;
  if (category) {
    categoryData = JSON.parse(category);
  }

  const subCategory = localStorage.getItem("admin-sub-category-data");
  let subCategoryData = null;
  if (subCategory) {
    subCategoryData = JSON.parse(subCategory);
  }

  const isOrganizationRoute = () => {
    // return selected_organization_id !== null && selected_organization_id !== "";
    
    return location.pathname.startsWith("/organization/");
  };

  useEffect(() => {
    if (selected_organization_id) {
      const fetchOrganization = async () => {
        setLoading(true);
        try {
          const result = await dispatch(
            getOrganizationDetails(selected_organization_id)
          );
          if (
            result &&
            result.payload &&
            result.payload.success === true &&
            result.payload.data === null
          ) {
            navigate("/");
          }
        } catch (error) {
          console.error("Error fetching organization details:", error);
          navigate("/");
        } finally {
          setLoading(false);
        }
      };
      fetchOrganization();
    }
  }, [selected_organization_id, dispatch, setLoading, navigate]);

  useEffect(() => {
    const handleTitleChange = () => {
      const data = JSON.parse(localStorage.getItem("admin-page-data"));
      if (
        location.pathname.startsWith(
          `/organization/${selected_organization_id}/page/`
        )
      ) {
        setTitle(data || "Page");
      }
    };

    window.addEventListener("page-title-updated", handleTitleChange);

    return () => {
      window.removeEventListener("page-title-updated", handleTitleChange);
    };
  }, [location.pathname, selected_organization_id]);

  useEffect(() => {
    let title = "dashboard"; // Default title

    if (location.pathname === "/") {
      title = "dashboard";
    } else if (
      location.pathname ===
      `/organization/${selected_organization_id}/color-configuration`
    ) {
      title = "Colors Configuration";
    } else if (location.pathname === "/organizations") {
      title = "organizations";
    } else if (location.pathname === "/organization-add") {
      title = "add New organization";
    } else if (location.pathname.startsWith("/organization-edit/")) {
      title = "Edit organization";
    } else if (location.pathname === "/templates") {
      title = "templates";
    } else if (location.pathname === "/template-add") {
      title = "add New template";
    } else if (location.pathname.startsWith("/template-edit/")) {
      title = "Edit template";
    } else if (location.pathname === "/business-types") {
      title = "Business Types";
    } else if (location.pathname === "/business-type-add") {
      title = "add New Business Type";
    } else if (location.pathname.startsWith("/business-type-edit/")) {
      title = "Edit Business Type";
    } else if (location.pathname === "/organization-types") {
      title = "Organization Types";
    } else if (location.pathname === "/organization-type-add") {
      title = "add New Organization Type";
    } else if (location.pathname.startsWith("/organization-type-edit/")) {
      title = "Edit Organization Type";
    } else if (location.pathname === "/legal-firms") {
      title = "Legal Firms";
    } else if (location.pathname === "/legal-firm-add") {
      title = "add New Legal Firm";
    } else if (location.pathname.startsWith("/legal-firm-edit/")) {
      title = "Edit Legal Firm";
    } else if (location.pathname === "/countries") {
      title = "Countries";
    } else if (location.pathname === "/country-add") {
      title = "add New Country";
    } else if (location.pathname.startsWith("/country-edit/")) {
      title = "Edit Country";
    } else if (location.pathname === "/states") {
      title = "States";
    } else if (location.pathname === "/state-add") {
      title = "add New State";
    } else if (location.pathname.startsWith("/state-edit/")) {
      title = "Edit State";
    } else if (location.pathname === "/cities") {
      title = "Cities";
    } else if (location.pathname === "/city-add") {
      title = "add New City";
    } else if (location.pathname.startsWith("/city-edit/")) {
      title = "Edit City";
    } else if (
      location.pathname === `/organization/${selected_organization_id}`
    ) {
      title = "Organization Dashboard";
    } else if (
      location.pathname === `/organization/${selected_organization_id}/blogs`
    ) {
      title = "blogs";
    } else if (
      location.pathname === `/organization/${selected_organization_id}/blog-add`
    ) {
      title = "add New blog";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/blog-edit/`
      )
    ) {
      title = "Edit blog";
    } else if (
      location.pathname ===
      `/organization/${selected_organization_id}/target-regions`
    ) {
      title = "Target Regions";
    } else if (
      location.pathname ===
      `/organization/${selected_organization_id}/target-region-add`
    ) {
      title = "add New target region";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/target-region-edit/`
      )
    ) {
      title = "Edit target region";
    } else if (
      location.pathname ===
      `/organization/${selected_organization_id}/galleries`
    ) {
      title = "gallery";
    } else if (
      location.pathname ===
      `/organization/${selected_organization_id}/gallery-add`
    ) {
      title = "add New gallery";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/gallery-edit/`
      )
    ) {
      title = "Edit gallery";
      // } else if (location.pathname === `/organization/${selected_organization_id}/settings`) {
      //   title = "settings";
    } else if (
      location.pathname ===
      `/organization/${selected_organization_id}/categories`
    ) {
      title = "categories";
    } else if (
      location.pathname ===
      `/organization/${selected_organization_id}/category-add`
    ) {
      title = "add New category";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/category-edit/`
      )
    ) {
      title = "Edit category";
    } else if (
      location.pathname === `/organization/${selected_organization_id}/products`
    ) {
      title = "products";
    } else if (
      location.pathname ===
      `/organization/${selected_organization_id}/product-add`
    ) {
      title = "add New product";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/product-edit/`
      )
    ) {
      title = "Edit product";
    } else if (
      location.pathname ===
      `/organization/${selected_organization_id}/testimonials`
    ) {
      title = "Testimonials";
    } else if (
      location.pathname ===
      `/organization/${selected_organization_id}/testimonial-add`
    ) {
      title = "add New testimonial";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/testimonial-edit/`
      )
    ) {
      title = "Edit testimonial";
    } else if (
      location.pathname === `/organization/${selected_organization_id}/clients`
    ) {
      title = "Clients";
    } else if (
      location.pathname ===
      `/organization/${selected_organization_id}/client-add`
    ) {
      title = "add New client";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/client-edit/`
      )
    ) {
      title = "Edit client";
    } else if (
      location.pathname === `/organization/${selected_organization_id}/teams`
    ) {
      title = "Teams";
    } else if (
      location.pathname === `/organization/${selected_organization_id}/team-add`
    ) {
      title = "add New team";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/team-edit/`
      )
    ) {
      title = "Edit team";
    } else if (
      location.pathname ===
      `/organization/${selected_organization_id}/inquiries`
    ) {
      title = "Inquiries";
    } else if (
      location.pathname ===
      `/organization/${selected_organization_id}/home-page`
    ) {
      title = "Home Page";
    } else if (
      location.pathname === `/organization/${selected_organization_id}/about-us`
    ) {
      title = "About Us Page";
    } else if (
      location.pathname ===
      `/organization/${selected_organization_id}/privacy-policy`
    ) {
      title = "Privacy Policy Page";
    } else if (
      location.pathname ===
      `/organization/${selected_organization_id}/terms-conditions`
    ) {
      title = "Terms & Conditions Page";
    } else if (
      location.pathname === `/organization/${selected_organization_id}/general`
    ) {
      title = "General Setting Page";
    } else if (
      location.pathname ===
      `/organization/${selected_organization_id}/company-details`
    ) {
      title = "Company Details Page";
    } else if (
      location.pathname === `/organization/${selected_organization_id}/domain`
    ) {
      title = "Domain Page";
    } else if (
      location.pathname ===
      `/organization/${selected_organization_id}/social-links`
    ) {
      title = "Social Links Page";
    } else if (
      location.pathname === `/organization/${selected_organization_id}/logo`
    ) {
      title = "Logo Page";
    } else if (
      location.pathname ===
      `/organization/${selected_organization_id}/google-analytics`
    ) {
      title = "Google Analytics Content";
    } else if (
      location.pathname ===
      `/organization/${selected_organization_id}/seo-configuration`
    ) {
      title = "SEO Configuration Page";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/child-categories`
      )
    ) {
      title = "child Categories";
    } else if (
      location.pathname ===
      `/organization/${selected_organization_id}/child-category-add`
    ) {
      title = "add New child category";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/child-category-edit/`
      )
    ) {
      title = "Edit child category";
    } else if (
      location.pathname === `/organization/${selected_organization_id}/pages`
    ) {
      title = "page";
    } else if (
      location.pathname === `/organization/${selected_organization_id}/page-add`
    ) {
      title = "add New page";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/page-edit/`
      )
    ) {
      title = "Edit page";
    } else if (
      location.pathname ===
      `/organization/${selected_organization_id}/plan-configuration`
    ) {
      title = "Plan Configuration";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/sub-category-products/`
      )
    ) {
      title = "Products";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/sub-category-product-add/`
      )
    ) {
      title = "add New product";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/sub-category-product-edit/`
      )
    ) {
      title = "Edit product";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/child-category-add/`
      )
    ) {
      title = "Add Child Category";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/page/`
      )
    ) {
      const data = JSON.parse(localStorage.getItem("admin-page-data"));
      title = data ? `${data}` : "Page";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/gallery-categories`
      )
    ) {
      title = "Gallery Category";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/gallery-category-add`
      )
    ) {
      title = "Add Category";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/gallery-category-edit/`
      )
    ) {
      title = "Edit Category";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/gallery-images`
      )
    ) {
      title = "Gallery Image";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/gallery-image-add`
      )
    ) {
      title = "Add Image";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/gallery-image-edit/`
      )
    ) {
      title = "Edit Image";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/gallery-videos`
      )
    ) {
      title = "Gallery Video";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/gallery-video-add`
      )
    ) {
      title = "Add Video";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/gallery-video-edit/`
      )
    ) {
      title = "Edit Video";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/faqs`
      )
    ) {
      title = "Add Color";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/add-color`
      )
    ) {
      title = "Edit Color";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/color-edit`
      )
    ) {
      title = "FAQs";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/faq-add`
      )
    ) {
      title = "Add FAQ";
    } else if (
      location.pathname.startsWith(
        `/organization/${selected_organization_id}/faq-edit/`
      )
    ) {
      title = "Edit FAQ";
    } else {
      title = "Not Found";
    }

    setTitle(title);
  }, [location.pathname, selected_organization_id]);

  const handleLogOut = async () => {
    try {
      await dispatch(logOut()).then((res) => {
        localStorage.removeItem("admin-auth-token");
        if (res.success) {
          setToastMessage(res.message || "Logout successful");
          setToastVariant("toast-success");
          setShowToast(true);
          setTimeout(() => {
            if (hasMounted) {
              navigate("/login");
            }
          }, 2000);
        }
      });

      setToastMessage("Logout successful");
      setToastVariant("toast-success");
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
      setToastMessage("Logout failed");
      setToastVariant("toast-danger");
      setShowToast(true);
      setTimeout(() => {
        if (hasMounted) {
          navigate("/login");
        }
      }, 2000);
    } finally {
      setTimeout(() => {
        if (hasMounted) {
          navigate("/login");
        }
      }, 2000);
    }
  };

  // const getUserInitial = (name) => {
  //   return name ? name.charAt(0).toUpperCase() : "U";
  // };

  return (
    <>
      <ToastContainer position="top-end" className="p-3">
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={3000}
          autohide
          bg={toastVariant}
          className="position-fixed top-3 end-0 me-3 shadow-none"
        >
          <Toast.Body className="d-flex align-items-center gap-1 lh-sm">
            <CheckmarkBadge04Icon
              width={18}
              height={18}
              color="#28c76f"
              strokeWidth="2"
            />
            <span className="text-capitalize">{toastMessage}</span>
          </Toast.Body>
        </Toast>
      </ToastContainer>
      <div className="px-4 py-2 bg-white position-sticky custom-navigationbar">
        <div className="d-flex align-items-center justify-content-between">
          {isOrganizationRoute() ? (
            <div className="d-flex align-items-center justify-content-between">
              <div
                onClick={() => {
                  navigate("/organizations");
                }}
                className="cursor-pointer"
              >
                {
                  <BackButtonIcon
                    width={22}
                    height={22}
                    color="#444050"
                    strokeWidth="2"
                  />
                }
              </div>
              <Link
                className="ms-4 cursor-pointer"
                to={`/organization/${organizationDetails?.id}`}
              >
                {organizationDetails?.logo && (
                  <h1>
                    <Image
                      style={{ maxHeight: "40px" }}
                      src={organizationDetails.logo}
                    />
                  </h1>
                )}
              </Link>
              <h5 className="ms-2 fw-semibold text-capitalize pg-title">
                {organizationDetails?.company_name}
              </h5>
            </div>
          ) : (
            <div className="bg-white position-sticky custom-navigationbar org-dashboard">
              <div className="my-1 d-flex align-items-center justify-content-between">
                <h5 className="fw-semibold text-capitalize pg-title">
                  {title}
                </h5>
              </div>
            </div>
            // <h5 className="fw-semibold text-capitalize pg-title">{title}</h5>
          )}
          <div className="d-flex align-items-center gap-3">
            {isOrganizationRoute() && organizationDetails?.domain_name && (
              <Button
                variant="primary"
                size="sm"
                className="me-3 d-flex align-items-center gap-1"
                onClick={() =>
                  window.open(`${organizationDetails.domain_name}`, "_blank")
                }
              >
                Visit Website {""}
                <ArrowUpRightIcon />
              </Button>
            )}
            <Dropdown className="profile-menu " align="end">
              <Dropdown.Toggle
                variant="link"
                id="dropdown-basic"
                className="position-relative p-0 profile-toggle"
              >
                {/* <Image
                src={dummyUser}
                className="h-100 w-100 d-inline-block"
                alt={`${userData?.data?.name} Image`}
                roundedCircle
              /> */}
                <div className="rounded-circle d-flex align-items-center justify-content-center user-profile-icon">
                  {getUserInitial(userData?.data?.name)}
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu className="mt-4 p-2 profile-submenu">
                <Dropdown.Item
                  href="#/action-1"
                  className="py-2 px-3  profile-menu-item"
                >
                  <div className="d-flex align-items-center gap-2">
                    <div className="position-relative flex-shrink-1 profile-user">
                      {/* <Image
                      src={dummyUser}
                      className="h-100 w-100 d-inline-block"
                      alt={`${userData?.data?.name} Image`}
                      roundedCircle
                    /> */}
                      <div className="rounded-circle d-flex align-items-center justify-content-center user-profile-icon">
                        {getUserInitial(userData?.data?.name)}
                      </div>
                    </div>
                    <div className="overflow-hidden flex-grow-1">
                      <h6 className="fw-medium text-capitalize mb-0">
                        {userData?.data?.name}
                      </h6>
                      <div className="text-capitalize post-tag">
                        {userData?.data?.company_name}
                      </div>
                    </div>
                  </div>
                </Dropdown.Item>
                <div className="profile-submenu-divider"></div>
                {/* <Dropdown.Item
                href="/profile"
                className="py-2 px-3 profile-menu-item"
              >
                <div className="d-flex align-items-center gap-2">
                  <UserStoryIcon
                    width={19}
                    height={19}
                    color="#444050"
                    strokeWidth="2"
                  />
                  <span className="ms-1 text-capitalize fw-normal">
                    My Profile
                  </span>
                </div>
              </Dropdown.Item> */}
                <div className="profile-submenu-divider"></div>
                <Dropdown.Item href="#" className="pt-2 pb-1 px-3  logout-btn">
                  <Button
                    variant="link"
                    onClick={handleLogOut}
                    className="w-100 text-white d-flex align-items-center justify-content-center text-decoration-none gap-2"
                  >
                    Logout
                    <span>
                      <Logout03Icon
                        width={15}
                        height={15}
                        color="#ffffff"
                        strokeWidth="2"
                      />
                    </span>
                  </Button>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>

      {/* { location.pathname.startsWith("/organization") && location.pathname !== "/organization/create" && location.pathname !== "/organizations" && */}
      {isOrganizationRoute() ? (
        location.pathname ===
        `/organization/${selected_organization_id}/child-categories` ? (
          // ONLY matches when there's no trailing slash or ID
          <div className="px-4 py-2 bg-white position-sticky custom-navigationbar mt-24">
            <div className="d-flex align-items-center">
              <div
                onClick={() => {
                  localStorage.removeItem("category_id_stack");
                  navigate(
                    `/organization/${selected_organization_id}/categories`
                  );
                }}
                className="cursor-pointer"
              >
                <BackButtonIcon
                  width={22}
                  height={22}
                  color="#444050"
                  strokeWidth="2"
                />
              </div>

              <h5 className="fw-semibold text-capitalize pg-title ms-2">
                {title} of {categoryData ? categoryData.category_name : ""}
              </h5>
            </div>
          </div>
        ) : location.pathname.startsWith(
            `/organization/${selected_organization_id}/child-categories/`
          ) ? (
          <div className="px-4 py-2 bg-white position-sticky custom-navigationbar mt-4">
            <div className="d-flex align-items-center">
              <div
                onClick={() => {
                  const categoryStack = JSON.parse(
                    localStorage.getItem("category_id_stack") || "[]"
                  );

                  if (categoryStack.length >= 2) {
                    // Remove current category (last)
                    categoryStack.pop();

                    // Get the previous category
                    const previousCategory =
                      categoryStack[categoryStack.length - 1];

                    // Update localStorage with the updated stack
                    localStorage.setItem(
                      "category_id_stack",
                      JSON.stringify(categoryStack)
                    );

                    localStorage.setItem(
                      "admin-category-data",
                      JSON.stringify({
                        id: previousCategory.id,
                        category_name: previousCategory.name,
                      })
                    );

                    // Navigate back
                    navigate(
                      `/organization/${selected_organization_id}/child-categories/${previousCategory.id}?page=1`
                    );
                  } else {
                    // Clear and go to root categories
                    localStorage.removeItem("category_id_stack");
                    localStorage.removeItem("admin-category-data");
                    navigate(
                      `/organization/${selected_organization_id}/categories`
                    );
                  }
                }}
                className="cursor-pointer"
              >
                <BackButtonIcon
                  width={22}
                  height={22}
                  color="#444050"
                  strokeWidth="2"
                />
              </div>
              <h5 className="fw-semibold text-capitalize pg-title ms-2">
                {title} of {categoryData ? categoryData.category_name : ""}
              </h5>
            </div>
          </div>
        ) : location.pathname.startsWith(
            `/organization/${selected_organization_id}/sub-category-products/`
          ) ? (
          <div className="px-4 py-2 bg-white position-sticky custom-navigationbar mt-4">
            <div className="d-flex align-items-center">
              <div
                onClick={() => {
                  const categoryStack = JSON.parse(
                    localStorage.getItem("category_id_stack") || "[]"
                  );

                  if (categoryStack.length >= 2) {
                    // Remove current category (last)
                    categoryStack.pop();

                    // Get the previous category
                    const previousCategory =
                      categoryStack[categoryStack.length - 1];

                    // Update localStorage with the updated stack
                    localStorage.setItem(
                      "category_id_stack",
                      JSON.stringify(categoryStack)
                    );

                    localStorage.setItem(
                      "admin-category-data",
                      JSON.stringify({
                        id: previousCategory.id,
                        category_name: previousCategory.name,
                      })
                    );

                    // Navigate back
                    navigate(
                      `/organization/${selected_organization_id}/child-categories/${previousCategory.id}?page=1`
                    );
                  } else {
                    // Clear and go to root categories
                    localStorage.removeItem("category_id_stack");
                    localStorage.removeItem("admin-category-data");
                    navigate(
                      `/organization/${selected_organization_id}/categories`
                    );
                  }
                }}
                className="cursor-pointer"
              >
                <BackButtonIcon
                  width={22}
                  height={22}
                  color="#444050"
                  strokeWidth="2"
                />
              </div>
              <h5 className="fw-semibold text-capitalize pg-title ms-2">
                {title} of {categoryData ? categoryData.category_name : ""}
              </h5>
            </div>
          </div>
        ) : location.pathname.startsWith(
            `/organization/${selected_organization_id}/sub-category-product-add/`
          ) ||
          location.pathname.startsWith(
            `/organization/${selected_organization_id}/sub-category-product-edit/`
          ) ? (
          <div className="px-4 py-2 bg-white position-sticky custom-navigationbar mt-4">
            <div className="d-flex align-items-center">
              <h5 className="fw-semibold text-capitalize pg-title ms-2">
                {title} of{" "}
                {subCategoryData ? subCategoryData.category_name : ""}
              </h5>
            </div>
          </div>
        ) : location.pathname.startsWith(
            `/organization/${selected_organization_id}/page/`
          ) ? (
          <div className="px-4 py-2 bg-white position-sticky custom-navigationbar mt-4">
            <div className="d-flex align-items-center">
              <div
                onClick={() => {
                  navigate(`/organization/${selected_organization_id}/pages`);
                }}
                className="cursor-pointer"
              >
                {
                  <BackButtonIcon
                    width={22}
                    height={22}
                    color="#444050"
                    strokeWidth="2"
                  />
                }
              </div>
              <h5 className="fw-semibold text-capitalize pg-title ms-2">
                {title}
              </h5>
            </div>
          </div>
        ) : location.pathname.startsWith(
            `/organization/${selected_organization_id}/child-category-add/`
          ) ? (
          <div className="px-4 py-2 bg-white position-sticky custom-navigationbar mt-4">
            <div className="d-flex align-items-center">
              <h5 className="fw-semibold text-capitalize pg-title ms-2">
                {title} of {categoryData ? categoryData?.category_name : ""}
              </h5>
            </div>
          </div>
        ) : (
          <div className="px-4 py-2 bg-white position-sticky custom-navigationbar mt-4 z-3">
            <div className="my-1 d-flex align-items-center justify-content-between ">
              <h5 className="fw-semibold text-capitalize pg-title ">{title}</h5>
            </div>
          </div>
        )
      ) : (
        ""
      )}
    </>
  );
}
